import React from 'react'
import HomeCardMetrics from './HomeCardMetrics'
import HomeCardCommunities from './HomeCardCommunities'

export default function HomeContainer() {

  return (
    <>
      <div className='home-container'>
        <HomeCardMetrics />
        <HomeCardCommunities/>
      </div>
    </>
  )
}